import { parse, isValid } from 'date-fns';
import React from 'react';
import { DatePicker } from 'react-widgets';
import { DatePickerProps } from 'react-widgets/cjs/DatePicker';
import { useTranslate } from '../../mixins/translate/translate';
import { appContext } from '../appContext';

function parseDate(dateString: string, locale: string) {
    const formats = locale === 'nl' ? ['dd-MM-yyyy', 'dd/MM/yyyy'] : ['MM-dd-yyyy', 'MM/dd/yyyy'];

    for (const format of formats) {
        const date = parse(dateString, format, new Date());
        if (isValid(date)) {
            return date;
        }
    }
    return undefined;
}

export function LocalizedDatePicker(props: DatePickerProps) {
    const translate = useTranslate();
    const { languageCode } = React.useContext(appContext.context);

    return (
        <DatePicker
            parse={(dateString) => parseDate(dateString, languageCode)}
            {...props}
            calendarProps={{ messages: { moveToday: translate('common.today') } }}
        />
    );
}
